import * as React from 'react'
import * as styles from './scrollpage.css'
import * as classnames from 'classnames'
import { observer } from 'mobx-react'
import { StoreComponent, injectStores, IStore } from '../../store'
import { observable } from 'mobx'
import bind from 'bind-decorator'

export interface IScrollPageChildProps {
  scrollPos?: number
  scrollBy?: number
  scrollerData?: number[]
  scrollerRefs?: HTMLDivElement[]
}

/**
 *
 *
 * @export
 * @class ScrollPageChild
 * @extends {StoreComponent<IScrollPageChildProps, S>}
 * @template S the context
 *
 * The class must be implemented from a scroll child
 */

export class ScrollPageChild<P = {}, S = {}> extends StoreComponent<IScrollPageChildProps & P, S> {
  static snapPoints: number[] = [0]

  static slideScrollHeight (breakpoints: IStore): number {
    return 100
  }
}

interface ComponentConstructor<P = {}, S = {}> {
  new(props: IScrollPageChildProps & P, context: S): ScrollPageChild<P, S>
}

export interface ScrollChildren<P> {
  component: ComponentConstructor<P> & { snapPoints: number[], slideScrollHeight: (breakpoints: IStore) => number }
  props: P
}

interface IProps {
  videoUrl169?: string
  videoUrl916?: string
  active?: boolean

  pageClassName?: string

  className?: string
  children: ScrollChildren<any>[]
  sidenav: ScrollChildren<any>
  slideIdx: number
  gotoNext? (): void
}

@injectStores
@observer
export class ScrollPage extends StoreComponent<IProps> {
  @observable scrollPosition = 0

  elems: (HTMLDivElement | null)[] = []
  elemStarts: number[] = []
  elemEnds: number[] = []

  scrollElement: HTMLDivElement | null = null

  sidenav: HTMLDivElement | null = null

  componentDidMount () {
    if (this.scrollElement) {
      if (this.store.breakpoints.phone) {
        this.scrollElement.addEventListener('scroll', this.handleScroll, true)
        // this.scrollElement.addEventListener('touchmove', this.handleScroll, true)
      } else {
        this.scrollElement.addEventListener('scroll', this.handleScroll, true)
      }
    }
    this.store.storyDocUI.scrollPositions[this.props.slideIdx] = 0
    // console.log(this.elemStarts)
    // console.log(this.elemEnds)
    this.refreshSizes()
  }

  componentDidUpdate () {
    this.refreshSizes()

    if (this.props.active && this.store.breakpoints.desktop) {
      if (this.scrollPosition < 10) {
        if (this.store.storeCommon.currentStory.play || this.store.storeCommon.currentStory.paused) {
          this.store.storeCommon.menu.showProgressBar = false
        } else {
          this.store.storeCommon.menu.showProgressBar = true
        }
      } else {
        this.store.storeCommon.menu.showProgressBar = false
      }
    } else if (this.store.breakpoints.phone) {
      this.store.storeCommon.menu.showProgressBar = true
    }

  }

  @bind
  refreshSizes () {
    this.elemStarts = []
    this.elemEnds = []
    for (const el of this.elems) {
      if (el) {
        const child = el.firstChild as HTMLElement
        if (child) {
          // const childRect = child.getBoundingClientRect()
          const elRect = el.getBoundingClientRect()
          // console.log(elRect)
          this.elemStarts.push(el.offsetTop)
          this.elemEnds.push(elRect.height - this.store.storeCommon.window.height)
        }
      }
    }
  }

  @bind
  handleScroll (e: any) {
    // if (e.target.scrollTop > this.scrollPosition) {
    //   this.scrollDown = true
    // } else {
    //   this.scrollDown = false
    // }
    if (this.props.active) {
      // window.requestAnimationFrame(() => {
      this.scrollPosition = Math.max(e.target.scrollTop, this.scrollElement && this.scrollElement.scrollTop || 0)
      this.store.storyDocUI.scrollPositions[this.props.slideIdx] = this.scrollPosition
      // })
    }

    // this.handleSnapDebounces()

  }

  normalizeScrollForElement (scrollPosition: number, start: number, height: number) {
    // console.log(`scrollPosition: ${scrollPosition} start: ${start} height: ${height ? height : 'no height'}`)

    // 5px to be on a safe side because browsers calculate heights close to 0 differently
    let normalizer = height > 5 ? (scrollPosition - start) / (height) : (scrollPosition - start) / this.store.storeCommon.window.height + 1
    if (normalizer < -1) {
      normalizer = -1
    } else if (normalizer > 2) {
      normalizer = 2
    }
    return normalizer
  }

  render () {
    const slides = []
    const scrollerData = []
    let i = 0
    for (const slide of this.props.children) {
      const ii = i
      let normalizer = 0
      if (this.elems.length > 0) {
        normalizer = this.normalizeScrollForElement(this.scrollPosition, this.elemStarts[ii], this.elemEnds[ii])
      } else {
        normalizer = this.scrollPosition ? this.store.storeCommon.window.height / this.scrollPosition : 1
      }
      scrollerData.push(normalizer)
      slides.push(
        <div
          key={ii}
          ref={elem => this.elems[ii] = elem}
        >
          <slide.component scrollPos={normalizer} {...slide.props} />
        </div >
      )
      i += 1
    }
    // console.log(scrollerData)
    const Sidenav = this.props.sidenav
    const sidebar = <div
      key='sidebar'
      ref={sidebar => this.sidenav = sidebar}
    >
      <Sidenav.component {...this.props.sidenav.props} scrollerData={scrollerData} scrollerRefs={this.elems}/>
    </div >

    return (
      <div className={classnames(styles.page, this.props.pageClassName)} style={{ height: this.store.storeCommon.window.height }}>
        {this.props.active && sidebar}
        <div className={styles.pageScrollbarhider}>
          <div className={styles.pageScroller} onClick={this.props.gotoNext} ref={(elem) => this.scrollElement = elem}>
            <div className={classnames(styles.pageContent, this.props.className)}>
              {slides}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/scrollpage.tsx